import * as yup from "yup";
import { validationArraySelect, validationConfirmNewPasswordL, validationEmailField, validationNewPassword, validationNotEmpty, validationStringSelect } from "./defaultValidations";

export const createCompany =  yup.object({
  cpnName: validationNotEmpty("Company Name"),
  cpnEmail: validationEmailField("Company Email"),
  industry: validationStringSelect("Industry"),
  address: validationNotEmpty("Address"),
  cpnPhone: validationNotEmpty("Company Phone"),
  PICname: validationNotEmpty("PIC Name"),
  PICemail: validationEmailField("PIC Email"),
  PICposition: validationNotEmpty("PIC Position"),
  PICphone: validationNotEmpty("PIC Phone"),
  PICremarks: validationNotEmpty("PIC Remarks"),
  cpnRegNum: validationNotEmpty("Company Registration Number"),
  cpnVAT: validationNotEmpty("Company VAT"),
  status: validationStringSelect("Status"),
});

